import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { NumericTextBoxModule } from "@progress/kendo-angular-inputs";
import { PopoverModule } from "ngx-popover";
import { Direct } from "protractor/built/driverProviders";
import { CalendarioModule } from "../../../../shared/components/calendario/calendario.module";
import { PipesModule } from "../../../../shared/_pipes/pipes.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { GestionComponent } from "./gestion.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        PipesModule,
        DirectivesModule,
        PopoverModule,
        DropDownListModule,
        NumericTextBoxModule,
        CalendarioModule
    ],
    declarations: [
        GestionComponent
    ],
    exports: [
        GestionComponent
    ]
})
export class GestionModule { }
